(function () {
  var EXTRA_OFFSET = 16;

  function getScrollOffset() {
    var root = document.documentElement;
    var value = getComputedStyle(root).getPropertyValue('--rabitat-header-height').trim();

    if (value) {
      if (value.endsWith('rem')) {
        return parseFloat(value) * parseFloat(getComputedStyle(root).fontSize) + EXTRA_OFFSET;
      }

      if (value.endsWith('px')) {
        return parseFloat(value) + EXTRA_OFFSET;
      }
    }

    var header = document.querySelector('[data-rabitat-header-group]');
    return (header ? header.offsetHeight : 80) + EXTRA_OFFSET;
  }

  function stripHashFromUrl() {
    if (!window.location.hash) return;
    history.replaceState(null, '', window.location.pathname + window.location.search);
  }

  function scrollToTarget(target) {
    if (!target) return;

    var offset = getScrollOffset();
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: Math.max(top, 0),
      behavior: 'smooth',
    });

    if (target.id === 'MainContent' || target.hasAttribute('tabindex')) {
      window.setTimeout(function () {
        target.focus({ preventScroll: true });
      }, 400);
    }
  }

  function getSamePageHashTarget(link) {
    if (!link || link.hasAttribute('data-preserve-hash')) return null;

    var href = link.getAttribute('href');
    if (!href || href === '#') return null;

    var url;

    try {
      url = new URL(link.href, window.location.href);
    } catch (error) {
      return null;
    }

    if (!url.hash || url.hash === '#') return null;
    if (url.origin !== window.location.origin) return null;
    if (url.pathname !== window.location.pathname || url.search !== window.location.search) return null;

    return document.getElementById(decodeURIComponent(url.hash.slice(1)));
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('a[href*="#"]');
      var target = getSamePageHashTarget(link);

      if (!target) return;

      event.preventDefault();
      scrollToTarget(target);
      stripHashFromUrl();
    },
    true
  );

  function scrollToInitialHash() {
    if (!window.location.hash) return;

    var hash = window.location.hash;
    var target = document.getElementById(decodeURIComponent(hash.slice(1)));

    stripHashFromUrl();

    if (!target) return;

    window.setTimeout(function () {
      scrollToTarget(target);
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scrollToInitialHash);
  } else {
    scrollToInitialHash();
  }
})();
